<template>
  <div style="width: 100%;height: 100%;overflow:auto;">
    <el-form label-width="130px" style="margin-top: 10px;">
      <el-row>
        <el-col :span="11">
          <el-form-item label="年度" required>
            <el-select v-model="year" @change="getProductNameByYear" disabled>
              <el-option v-for="year in yearList" :key="year.value" :value="year.value" :label="year.label"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="公司" required>
            <el-select v-model="company" disabled>
              <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="display: flex;text-align: center;background-color: #cccccc;line-height: 30px">
      <div style="width: 100px;">序号</div>
      <div style="flex: 1">产品名称</div>
      <div style="width: 180px;">金额($)</div>
      <div style="width: 180px">销量(套)</div>
    </div>

    <el-scrollbar style="width: 100%;height: 350px;">
      <div style="display: flex;margin-top: 5px;line-height: 30px;text-align: center;" v-for="(item,index) in productNameList">
        <div style="width: 100px;">{{ index + 1 }}.</div>
        <div style="flex: 1">{{ item.product_name }}</div>
        <div style="width: 180px;">
          <el-input-number v-model="item.price" min="0" :controls="false" :precision="2" @change="calculatePrice"></el-input-number>
        </div>
        <div style="width: 180px;">
          <el-input-number v-model="item.sales_cnt" min="0" :controls="false" @change="calculatePrice"></el-input-number>
        </div>
      </div>
    </el-scrollbar>

    <div style="display: flex;text-align: center;margin-top: 10px;line-height: 30px;background-color: #cccccc">
      <div style="width: 100px;">合计</div>
      <div style="flex: 1"></div>
      <div style="width: 180px;">{{ priceSum }}</div>
      <div style="width: 180px;">{{ salesCnt }}</div>
    </div>

    <div style="width: 100%;text-align: center;margin-top: 20px">
      <el-button type="primary" style="width: 150px;" @click="addYearMission">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditYearMission",

  inject: ['$fn'],

  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  data(){
    return{
      productNameList:[],
      companyList:[],
      yearList:[],
      year:'',
      company:'',
      priceSum:0,
      salesCnt:0
    }
  },
  async created() {
    await this.initData();
  },
  methods: {
    addYearMission() {
      let params = {year: this.year, company: this.company, productList: this.productNameList}
      this.$http('crmDsTaskService.editYearMission', params).then(() => {
        this.$fn.closeWindow();
        this.$fn.search();
        this.$message.success("提交成功");
      });
    },
    async initData() {
      this.yearList = await this.$http('sysDsService.getYears(5,2)')
      this.year = this.parentData.year;
      this.company = this.parentData.company;
      await this.getProductNameByYear();
      await this.getCompanyList();
    },
    async getProductNameByYear() {
      let params = {year: this.year,company:this.company}
      this.productNameList = await this.$http('crmDsTaskService.getProductNameByYearCompany', params);
      this.calculatePrice();

    },
    async getCompanyList(){
      this.companyList = await this.$http('crmTeamService.getCompanyList');
    },
    calculatePrice() {
      let priceSum = 0;
      let salesCnt = 0;
      this.productNameList.forEach(item => {
        if (item.price) {
          priceSum = priceSum + item.price;
        }
        if (item.sales_cnt) {
          salesCnt = salesCnt + item.sales_cnt;
        }
      })
      this.priceSum = priceSum;
      this.salesCnt = salesCnt;
    }
  }

  }
</script>

<style scoped>

</style>